// Modules
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
// Styles
import Styles from "./Styles/UserPanelSideBar.module.css";
// Images
import logoImage from "../../../Assets/Images/logo-white.png";
import homeImage from "../../../Assets/Icons/home.png";
import onlineLearningImage from "../../../Assets/Icons/online-learning-white.png";
import messageImage from "../../../Assets/Icons/message.png";
import supportImage from "../../../Assets/Icons/support-white.png";
// import payImage from "../../../Assets/Icons/pay.png";
import shopImage from "../../../Assets/Icons/shop.png";
import dashboardImage from "../../../Assets/Icons/dashboard (2).png";

const UserPanelSideBar = () => {
  return (
    <motion.div
      initial={{ x: 600 }}
      animate={{ x: 0 }}
      transition={{ duration: 0.8 }}
      className={Styles.container}
    >
      <img src={logoImage} alt="" className={Styles.logoContainer} />
      <Link to="/" className={Styles.itemContainer}>
        <h3>صفحه اصلی</h3>
        <img src={homeImage} alt="" />
      </Link>
      <Link to="/users/panel" className={Styles.itemContainer}>
        <h3>داشبورد</h3>
        <img src={dashboardImage} alt="" />
      </Link>
      <div className={Styles.itemContainer}>
        <div className={Styles.textContainer}>
          <h3>صندوق پیام</h3>
          <h6>بزودی</h6>
        </div>
        <img src={messageImage} alt="" />
      </div>
      <Link to="/library/my-books" className={Styles.itemContainer}>
        <h3>کتابهای من</h3>
        <img src={onlineLearningImage} alt="" />
      </Link>
      <div className={Styles.itemContainer}>
        <div className={Styles.textContainer}>
          <h3>پشتیبانی</h3>
          <h6>بزودی</h6>
        </div>
        <img src={supportImage} alt="" />
      </div>
      <Link to="/users/panel/cart" className={Styles.itemContainer}>
        <h3>سبد خرید</h3>
        <img src={shopImage} alt="" />
        {/* {itemsCount !== 0 && <h6>{itemsCount}</h6>} */}
      </Link>
      {/* <div className={Styles.itemContainer}>
        <div className={Styles.textContainer}>
          <h3>پرداخت ها</h3>
          <h6>بزودی</h6>
        </div>
        <img src={payImage} alt="" />
      </div> */}
    </motion.div>
  );
};

export default UserPanelSideBar;
